// Vendors
import React from 'react';
// Components
import { SnackbarComponent, SnackbarComponentType } from '@openbank/ziniaweb-ui-components';
// Constants
import { SNACKBAR_PROPS } from './constants/session-expire.constants';
// Hooks
import { useSessionExpireHook } from './hooks/session-expire.hook';
// Types
import { ReactChildrenType } from '@openbank/ziniaweb-ui-core-models';

const SessionExpireProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  const { handleCloseWarningMessage, openSnackbar, sessionWarningMessage } = useSessionExpireHook();

  return (
    <>
      {children}
      <SnackbarComponent
        {...({
          ...SNACKBAR_PROPS,
          title: sessionWarningMessage,
          onCloseButton: handleCloseWarningMessage,
          open: openSnackbar,
        } as SnackbarComponentType)}
      />
    </>
  );
};

export { SessionExpireProvider };
